"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _colors = require("@mui/material/colors");
let theme = (0, _material.createTheme)({
  palette: {
    primary: {
      main: _colors.indigo[500],
      normal: _colors.indigo[700]
    },
    secondary: {
      main: _colors.indigo[50]
    },
    neutral: {
      light: _colors.grey[50],
      medium: _colors.grey[200],
      normal: _colors.grey[700],
      main: _colors.grey[900]
    },
    green: {
      main: _colors.green[800]
    },
    blue: {
      main: '#3c8dbc'
    },
    sidebar: {
      main: '#3c8dbc',
      divider: '#fff',
      text: '#fff',
      active: '#2196f3'
    }
  }
});
theme = (0, _material.createTheme)(theme, {
  typography: {
    link: {
      fontSize: '0.8rem',
      [theme.breakpoints.up('md')]: {
        fontSize: '0.9rem'
      },
      fontWeight: 500,
      color: theme.palette.primary.normal,
      display: 'block',
      cursor: 'pointer'
    }
  },
  cardTitle: {
    fontSize: '1.2rem',
    display: 'block',
    fontWeight: 500
  },
  h6: {
    fontSize: '1rem'
  },
  h7: {
    fontSize: '0.8rem'
  },
  h8: {
    fontSize: '0.7rem'
  },
  layout: {
    root: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh"
    },
    header: {
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
      zIndex: 1200,
      width: '100vw',
      position: "sticky",
      top: 0,
      bgcolor: theme.palette.primary.main,
      height: 64,
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    contentWrapper: {
      display: "flex",
      flexGrow: 1,
      width: "100%"
    },
    sidebar: {
      boxShadow: "inset -2px 0px 4px rgba(0, 0, 0, 0.1)",
      zIndex: 100,
      position: "relative",
      width: 250,
      bgcolor: theme.palette.neutral.light,
      transition: "width 0.3s ease"
    },
    sidebarCollapsed: {
      width: 80,
      position: 'static',
      bgcolor: theme.palette.neutral.light,
      transition: "width 0.3s ease"
    },
    sidebarCollapsedMobile: {
      display: 'none'
    },
    mainContent: {
      flexGrow: 1,
      display: "flex",
      flexDirection: "column",
      justifyContent: "space-between",
      minHeight: "calc(100vh - 64px)",
      overflowY: "auto"
    },
    footer: {
      marginTop: 2
    }
  }
});
var _default = exports.default = theme;